import React from "react";

import "./ProgressBar.css";

import { CircleTick } from "./../../../Common/Svg";
import { Text } from "./../../../../StyledComponents/Text";

export default (props) => {
  const getProgressItem = (progress) => {
    switch (progress.status) {
      case "COMPLETE":
        return <ProgressCompleteItem key={progress.value} {...progress} />;
      case "IN_PROGRESS":
        return <InProgressItem key={progress.value} {...progress} />;
      default:
      case "PENDING":
        return <PendingProgressItem key={progress.value} {...progress} />;
    }
  };

  if (props.progresBarData.length === 0) {
    return null;
  }

  return (
    <div
      className="progress-bar__progress-bar-container"
      automationid="SalesLeads_Div_ProgressWeb-1"
    >
      <div
        className="progress-bar__progress-bar"
        automationid="SalesLeads_Div_ProgressWeb-2"
      ></div>
      {props.progresBarData.map((item) => getProgressItem(item))}
    </div>
  );
};

const ProgressCompleteItem = (props) => {
  return (
    <div
      className="progress-bar__progress-item-wrapper"
      automationid="SalesLeads_Div_ProgressWeb-3"
    >
      <div
        className="progress-bar__progress-step-wrapper"
        automationid="SalesLeads_Div_ProgressWeb-4"
      >
        <CircleTick />
      </div>
      <Text
        color="white"
        fontSize="14px"
        fontWeight="300"
        automationid="SalesLeads_P_ProgressWeb-5"
      >
        {props.title}
      </Text>
    </div>
  );
};

const InProgressItem = (props) => {
  return (
    <div
      className="progress-bar__progress-item-wrapper"
      automationid="SalesLeads_Div_ProgressWeb-6"
    >
      <div
        className="progress-bar__progress-step-wrapper"
        automationid="SalesLeads_Div_ProgressWeb-7"
      >
        <div
          className="progress-bar__progress-step progress-bar__progress-step-complete"
          automationid="SalesLeads_Div_ProgressWeb-8"
        >
          {props.value}
        </div>
      </div>
      <Text
        color="white"
        fontSize="14px"
        fontWeight="700"
        automationid="SalesLeads_P_ProgressWeb-10"
        className="progress-bar__progress-step-complete-title"
      >
        {props.title}
      </Text>
    </div>
  );
};

const PendingProgressItem = (props) => {
  return (
    <div
      className="progress-bar__progress-item-wrapper"
      automationid="SalesLeads_Div_ProgressWeb-21"
    >
      <div
        className="progress-bar__progress-step-wrapper"
        automationid="SalesLeads_Div_ProgressWeb-22"
      >
        <div
          className="progress-bar__progress-step"
          automationid="SalesLeads_Div_ProgressWeb-23"
        >
          {props.value}
        </div>
      </div>
      <Text
        color="white"
        fontSize="14px"
        fontWeight="300"
        automationid="SalesLeads_P_ProgressWeb-23"
      >
        {props.title}
      </Text>
    </div>
  );
};
